module.exports = __webpack_public_path__ + "img/BLANCO_Desarrollo.4eb2be67.png";